<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre1" id="untitled-1">
<div class="calibre1">
<p class="normal"><span class="no-style-override9"><br class="calibre1"/></span></p>
</div>
<div class="calibre1">
<p class="chapter-sub">Cast of Primary Characters</p>
<p class="chapter-sub">The port side of the Atlantic </p>
<p class="normal-310-0-override3"><span class="no-style-override16">Max Blake:</span><span class="no-style-override7"> Private detective; retired college professor and former investigative reporter</span></p>
<p class="normal-310-0-override3"><span class="no-style-override16">Caeli Brown:</span><span class="no-style-override7"> Max’s fiancée/business partner and a former newspaper reporter </span></p>
<p class="normal-310-0-override3"><span class="no-style-override16">Bill Kohlmeyer:</span><span class="no-style-override7"> Chief of police of Oregon’s capital city</span></p>
<p class="normal-310-0-override3"><span class="no-style-override16">Fredo Fierro: </span><span class="no-style-override7">The new </span><span class="no-style-override8">capo di tutti capi</span><span class="no-style-override7">; Max’s and Caeli’s friend and sole client</span></p>
<p class="normal-310-0-override3"><span class="no-style-override16">Elmore and Leonard: </span><span class="no-style-override7">Fierro Enterprises (USA) employees/bodyguards  </span></p>
<p class="normal-310-0-override3"><span class="no-style-override16">Michael J. Parker:</span><span class="no-style-override7"> Max’s and Caeil’s friend and attorney</span></p>
<p class="normal-310-0-override3"><span class="no-style-override16">Dr. Floyd Strand:</span><span class="no-style-override7"> Max’s friend, golf buddy, and medical adviser</span></p>
<p class="normal-310-0-override3"><span class="no-style-override16">Mitts: </span><span class="no-style-override7">Caeli’s 26-pound Maine Coon cat</span></p>
<p class="normal-310-0-override3"><span class="no-style-override16">Koko:</span><span class="no-style-override7"> Caeli’s midnight-black rescue cat</span></p>
<p class="chapter-sub">The starboard side of the Atlantic  </p>
<p class="normal-310-0-override3"><span class="no-style-override16">The Rev. Sean “Jack” O’Lennox:</span><span class="no-style-override7"> Caeli’s uncle, the former Archbishop of Armagh</span></p>
<p class="normal-310-0-override3"><span class="no-style-override16">Roberto Fierro: </span><span class="no-style-override7">The late Don Vincenzo’s lookalike brother; Fredo’s uncle</span></p>
</div>
<div class="calibre1">
<p class="normal-310-0-override3"><span class="no-style-override16">Guglielmo Morandini:</span><span class="no-style-override7"> Don Roberto’s gardener and occasional chauffer </span></p>
<p class="normal-310-0-override3"><span class="no-style-override16">Monsignor Luca LaGuardia: </span><span class="no-style-override7">Papal wheeler-dealer  </span></p>
<p class="normal-310-0-override3"><span class="no-style-override16">Father Antonio Rizzo:</span><span class="no-style-override7"> Resident Vatican good guy</span></p>
<p class="normal-310-0-override3"><span class="no-style-override16">Father Pietro Angelus:</span><span class="no-style-override7"> Resident Vatican bad guy</span></p>
<p class="normal-310-0-override3"><span class="no-style-override16">Penn and Teller:</span><span class="no-style-override7"> Fierro Enterprises (International) employees</span></p>
<p class="normal-310-0-override3"><span class="no-style-override16">Bruno Coretti:</span><span class="no-style-override7"> the Mayor of Nepi, Italy</span></p>
<p class="normal-310-0-override3"><span class="no-style-override16">Ruth Coretti:</span><span class="no-style-override7"> Kidnap victim and the mayor’s wife</span></p>
<p class="normal-310-0-override3"><span class="no-style-override16">Chiara Coretti:</span><span class="no-style-override7"> Bruno’s and Ruth’s daughter</span></p>
<p class="calibre3" id="calibre_pb_16"></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// CastOfCharacters.vue?1d53f87f